import { useRef } from "react";
import { HiMiniPaintBrush } from "react-icons/hi2";
import { MdCloudUpload } from "react-icons/md";
// import { MdChat } from "react-icons/md";
import ArtSelectionOption from "./ArtSelectionOption";
import ModalWrapper from "./ModalWrapper";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { formatError, logError } from "../services/logging";
import { API_URL } from "../config/api";

function CreateArtworkModal({ isOpen, onClose, promptId }) {
  const fileInputRef = useRef(null)
  const navigate = useNavigate()

  // reference to invisible file picker input
  const handleUploadClick = () => {
    fileInputRef.current?.click()
  }

  const handleFileChange = async (e) => {
    const file = e.target.files[0]
    if(!file) return

    const formData = new FormData()
    formData.append("image", file)
    formData.append("prompt_id", promptId)

    try {
      // upload image to Cloudinary
      const uploadResp = await fetch(`${API_URL}/api/upload`, {
        method: "POST",
        body: formData
      })

      if (!uploadResp.ok) {
        const errorData = await uploadResp.json()
        logError(errorData)
        toast.error("Image upload failed. Please try again.")
        return
      }
      
      const imgURL = await uploadResp.text()
        
      // save new Artwork to database
      const artworkResp = await fetch(`${API_URL}/api/artworks`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        credentials: "include",
        body: JSON.stringify({
          prompt_id: promptId,
          image_url: imgURL,
          image_type: "upload"
        })
      })

      if (!artworkResp.ok) {
        const errorData = await artworkResp.json()
        logError(errorData)
        toast.error(errorData.message || "Failed to save artwork.")
        return
      }

      const artwork = await artworkResp.json()
      toast.success("Artwork uploaded successfully!")
      onClose()
      navigate(`/artwork/${artwork.id}`)

    } catch (error) {
      logError(formatError(error))
      toast.error("An unexpected error occurred. Please try again.")
    }
  }

  return (
    <ModalWrapper 
      isOpen={isOpen} 
      onClose={onClose} 
      title="Choose an option:"
    >
        <section className="link-container">

          <ArtSelectionOption 
            icon={<HiMiniPaintBrush/>}
            title="Canvas"
            description="Use the canvas and art tools to create the image."
            to={`/prompt/${promptId}/canvas`}
          />

          <ArtSelectionOption 
            icon={<MdCloudUpload/>}
            title="Upload"
            description="Upload a drawing, photo, or digital artwork."
            onClick={handleUploadClick}
          />
          <input
            type="file"
            accept="image/*"
            ref={fileInputRef}
            onChange={handleFileChange}
            style={{ display: "none" }}
          />

          {/* <ArtSelectionOption 
            icon={<MdChat/>}
            title="AI"
            description="Use the AI to create the image you have in mind."
            to={`/prompt/${promptId}/chat`}
          /> */}

        </section>
      </ModalWrapper>
  );
}

export default CreateArtworkModal;
